module.exports = __webpack_public_path__ + "img/Burger and drink Icon - white.df2ad65a.svg";